module.exports = __webpack_public_path__ + "img/step56_a_printer_basic_install_left_rear_cover.ae728226.png";